import { Flex, Text } from '@chakra-ui/react';
import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Modal } from '@morressier/alembic';

interface RequestCancelModalProps {
  onExit: () => void;
  onClose: () => void;
}

export const CancelRequestSubmissionUpdatesConfirmationModal = ({
  onClose,
  onExit
}: RequestCancelModalProps) => {
  return (
    <Modal isOpen onClose={onClose} width="448px" data-cy="confirmation-modal">
      <Flex padding={8} gap={6} flexDirection="column">
        <Flex
          alignItems="flex-start"
          flexDirection="column"
          color="actionSecondaryCautionContent"
        >
          <FontAwesomeIcon fontSize={32} icon={faExclamationTriangle} />
        </Flex>

        <Flex flexDirection="column" gap={2}>
          <Text textStyle="headingGroup">Exit Without Finishing?</Text>
          <Text>
            You are about to leave this page. Are you sure you want to continue?
          </Text>
        </Flex>

        <Flex gap={2} justifyContent="flex-end">
          <Button
            onClick={onClose}
            variant="secondary"
            data-cy="request-submission-modal-cancel-button"
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="caution"
            onClick={onExit}
            data-cy="request-submission-modal-submit-button"
          >
            Exit
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};
